import { render, staticRenderFns } from "./warehouse-update.vue?vue&type=template&id=394e7dfe&scoped=true&"
import script from "./warehouse-update.vue?vue&type=script&lang=js&"
export * from "./warehouse-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394e7dfe",
  null
  
)

export default component.exports